module.exports = __webpack_public_path__ + "img/wellness.583a20ea.svg";